//import Divider from '../../components/Common/Divider';
//import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

//import { Link } from 'react-router-dom';
//import SocialAuthButtons from './SocialAuthButtons';
import paths from '../../routes/paths';
import { useDispatch, useSelector } from 'react-redux';
//import { Navigate } from "react-router-dom"
import {ThunkDispatch} from "@reduxjs/toolkit";
import {loginUser,registerUser,adminLoginUser,loginModalClose} from '../../redux/slices/AuthSlice';
//import classnames from 'classnames'
import styles from './Auth.module.scss'
import ImageLogin from '../../assets/images/pic3.png'
import ValidationErrors from '../Common/ValidationErrors';
//import { toast } from 'react-toastify';


const LoginModal = () => {
  // State
  const [email, setEmail] = useState('') 
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [mobile, setMobile] = useState('');
  const [remember, setRemember] = useState(false);
  const [page, setPage] = useState("Login");
  const [inputTypePwd, setInputTypePwd] = useState("password");
  const [inputTypePwdConf, setInputTypePwdConf] = useState("password");
  const [displayValidations, setDisplayValidations] = useState(false);
  const [displayErrors, setDisplayErrors] = useState(false);

  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const { error,loading,formErrors,loginUserType,loginModalShow } = useSelector((state:any) => state.auth);

  const navigate = useNavigate();


  const handleLogin = () => {

    if (page === "Login"){ 
      setDisplayErrors(true)
      loginUserType === "User" && dispatch(loginUser( {customer: {email, password}})); 
      loginUserType === "Admin" && (
        dispatch(adminLoginUser( {admin: {email, password}}))
        .then((userData) => { 
          if(userData.payload.status === 'success'){
            navigate(paths.adminDashboard);
          }

        })
        .catch((error) => {
          // Handle login failure
          console.error('Login failed:', error);
        })
      ); 
    }   
    if (page === "Register"){  
      setDisplayValidations(true);
      dispatch(registerUser( {customer: {email, password, passwordConfirmation,firstName,lastName,mobile}}));   
    } 
  } 
 
  // if (loggedInUser !== null  && loggedInUser?.role !== 'User'){
  //   console.log("wwwwwwwwwww close" )
  //   onClose(); 
  // }

  //const notify = (msg) => toast.error(msg);

  const handleCreateAccount = () => {
    setDisplayErrors(false)
    setPage('Register'); 
    setDisplayValidations(false);
    setEmail("");
    setPassword("");
    setPasswordConfirmation("");
  }
  const handleLoginButton = () => {
    setPage('Login'); 
    setDisplayValidations(false);
    setDisplayErrors(false);
    setEmail("");
    setPassword("");
    setPasswordConfirmation("");
  }
  
  const onClose = () => {
     dispatch(loginModalClose());
  }
  //console.log("eeeeerrrr", modalShow)
  return ( 

 <Modal size="xl" show={loginModalShow} onHide={onClose} className='quick-view-modal'>
  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClose}>
    <i className="icon feather icon-x"></i>
  </button>
  <Modal.Body> 
    <div className="page-content bg-light">
      <section className="px-3">
        <div className="row">
          <div className="col-xxl-6 col-xl-6 col-lg-6 start-side-content p-t168 p-r80 p-b0 p-45">
  
            <div className="registration-media">
              <img src={ImageLogin} alt="Login Page"/>
            </div>
          </div>
          <div className="col-xxl-6 col-xl-6 col-lg-6 p-a50 justify-content-center">
            <div className="login-area">
              <h2 className="text-secondary text-center">{loginUserType} {page}</h2>
              {/* <p className="text-center m-b25">Please login to continue...</p> */}
              {page === "Login" && displayErrors && <p className={styles.error}>{error}</p>}
              {page === "Register" && displayValidations && <ValidationErrors errors={formErrors}/>}
              <form>
                <div className="m-b15">
                  <label className="label-title">Email Address</label>
                  <input name="dzName"  className="form-control" placeholder="Email Address" type="email" value={email}  onChange={(e) => setEmail(e.target.value)}/>
                </div>
                <div className="m-b15">
                  <label className="label-title">Password</label>
                  <div className="secure-input ">
                    <input type={inputTypePwd} name="password" className="form-control dz-password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}/>
                    <div className={"show-pass " + (inputTypePwd === "text" ? 'active' : '')} onClick={() => setInputTypePwd(inputTypePwd === "text" ? "password" : "text")}>
                      <i className="eye-open fa-regular fa-eye"></i>
                    </div>
                  </div>
                </div>
                {page === "Register" && 
                  <>
                    <div className="m-b15">
                      <label className="label-title">Password Confirmation</label>
                      <div className="secure-input ">
                        <input type={inputTypePwdConf} name="passwordConfirmation" className="form-control dz-password" placeholder="Password Confirmation" value={passwordConfirmation} onChange={(e) => setPasswordConfirmation(e.target.value)}/>
                        <div className={"show-pass " + (inputTypePwdConf === "text" ? 'active' : '')} onClick={() => setInputTypePwdConf(inputTypePwdConf === "text" ? "password" : "text")}>
                        <i className="eye-open fa-regular fa-eye"></i>
                        </div>
                      </div>
                    </div>
                    <div className="m-b15">
                      <label className="label-title">First Name</label>
                      <div className="secure-input ">
                        <input type="text" name="firstName" className="form-control" placeholder="First Name" value={firstName} onChange={(e) => setFirstName(e.target.value)}/>
          
                      </div>
                    </div>
                    <div className="m-b15">
                      <label className="label-title">Last Name</label>
                      <div className="secure-input ">
                        <input type="text" name="lastName" className="form-control" placeholder="Last Name" value={lastName} onChange={(e) => setLastName(e.target.value)}/>
          
                      </div>
                    </div>
                    <div className="m-b15">
                      <label className="label-title">Mobile</label>
                      <div className="secure-input ">
                        <input type="text" name="mobile" className="form-control" placeholder="Mobile" value={mobile} onChange={(e) => setMobile(e.target.value)}/>
          
                      </div>
                    </div>
                 </>
                }
                {page === "Login" && 
                  <div className="form-row d-flex justify-content-between m-b30">
                    <div className="form-group">
                      <div className="custom-control custom-checkbox">
                        <input type="checkbox" className="form-check-input" id="basic_checkbox_1" checked={remember}   onChange={e => setRemember(!remember)} />
                        <label className="form-check-label" >Remember Me</label>
                      </div>
                    </div>
                    {loginUserType !== "Admin" && (
                      <div className="form-group">
                        <a className="text-primary" href="#!">Forgot Password</a>
                      </div>
                    )}
                    
                  </div>
                } 
               
              </form>
              <div className="text-center">
                    <button onClick={(e) => handleLogin()} className="btn btn-block btn-secondary btnhover text-uppercase m-b-10 me-2 sign-btn">{loading ? "Please wait..." : page}</button>
                </div>
              {page === "Login" && loginUserType !== "Admin" && <>New to website? <button onClick={() => handleCreateAccount()} className="removeBtnBG">Create an account</button></>}
              {page === "Register" && <>Already have an account? <button onClick={() => handleLoginButton()} className="removeBtnBG">Login</button></>}

            </div> 
          </div>
        </div>
      </section>
    </div>
  </Modal.Body> 
</Modal>
 
  );
};

 

export default LoginModal;
